import React, {useEffect, useContext} from 'react';
import Icon_Close from '../Assets/Icons/Icon_Close.png';
import Icon_Success from '../Assets/Icons/Icon_Color_EmailSent.png';
import { Context_UI } from '../Contexts/Context_UI';

export default function Subwindow_Modal_Register_RequestSent({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const Confirm = () => {
        UI.Subwindows_Close('Window_Register_Success');
    }

    useEffect(() => {
        const el = document.getElementById("Window_Register_Success");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    return (
        <ui-subwindow Type='Modal' id='Window_Register_Success' State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    
                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Success} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Verify your account
                </h2>
                
                <p className='General_Paragraph' style={{textAlign: "center", marginBottom: "10px"}}>
                    Click the link that will be sent to your email to continue with the registration process.
                </p>
                
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                    Close
                </button>
                {/* <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                    Resend verification
                </button> */}
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
